import { Backdrop, Box, Card, Divider, IconButton, Modal, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';

interface SwyftModalProps {
  open: boolean;
  showCloseButton?: boolean;
  onClose: () => void;
  width?: number;
  height?: number | string;
  children: React.ReactNode;
  title?: string | React.ReactNode;
  modalStyle?: 'default' | 'small';
  minHeight?: number | string;
  outsideClose?: boolean;
  padding?: number;
  maxWidth?: number | string;
}

export const SwyftModal = ({
  open,
  title,
  onClose,
  children,
  width = 600,
  showCloseButton = true,
  modalStyle = 'default',
  minHeight = 'auto',
  outsideClose = true,
  height = 'auto',
  padding = 3,
  maxWidth = 'auto'
}: SwyftModalProps) => (
  <Box clone display={'flex'} alignItems={'center'} justifyContent={'center'}>
    <Modal
      open={open}
      onClose={() => (outsideClose ? onClose() : null)}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Card style={{ width, height, minHeight, maxWidth, maxHeight: '90vh', overflow: 'auto', outline: 'none' }}>
        <Box padding={padding} height='100%'>
          <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography variant={modalStyle === 'default' ? 'h5' : 'body2'}>{title}</Typography>
            {showCloseButton && (
              <IconButton className='swyft-close-button' color='primary' onClick={() => onClose()}>
                <Close fontSize='small' />
              </IconButton>
            )}
          </Box>
          {modalStyle === 'default' && (
            <Box my={3}>
              <Divider />
            </Box>
          )}
          {children}
        </Box>
      </Card>
    </Modal>
  </Box>
);
